import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-slate-500 text-sm" data-testid="auth-loading">
        Loading Ayobell Care…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
